module.exports = __webpack_public_path__ + "img/medical.83c87ec3.svg";